

























import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'CreateFillerPDF',
    props: [ 'template' ],
    data() {
        return {
            disableButton: false,
            formData: {
                template: '',
                contactId: null,
                companyId: null
            },
            showPDFLink: false,
            PDFLink: '',
            searchContactInput: '',
            searchContactResults: [] as any,
            contactSearchDebounceTimer: null as any,
            searchCompanyInput: '',
            searchCompanyResults: [] as any,
            companySearchDebounceTimer: null as any
        }
    },
    created() {
        this.formData.template = this.$props.template;
    },
    methods: {
        submit() {
            this.disableButton = true;
            axios.post(`${this.$store.state.apiUrl}/filler`, this.formData)
                .then(resp => {
                    this.disableButton = false;
                    this.PDFLink = `${this.$store.state.apiUrl}/pdf/${resp.data}`;
                    this.showPDFLink = true;
                })
                .catch(e => {
                    console.log(e.response?.data ? e.response.data : e);
                    // The backend now sends { code, message } for every handled
                    // failure - show its message directly instead of guessing
                    // from a status code, so the real cause (an expired HubSpot
                    // connection, a bad field mapping, a HubSpot-side error, etc.)
                    // is visible instead of a generic dead end.
                    const message = e.response?.data?.message;
                    alert(message || 'There was an error.');
                    this.disableButton = false;
                })
        },
        closeCreate() {
            this.$emit('closeCreate');
        },
        searchContacts() {
            axios.get(`${this.$store.state.apiUrl}/hsdata/search/contacts/${encodeURIComponent(this.searchContactInput)}`)
                .then(resp => {
                    this.searchContactResults = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        searchContactsDebounce() {
            clearTimeout(this.contactSearchDebounceTimer);
            this.contactSearchDebounceTimer = setTimeout(() => { this.searchContacts() }, 500);
        },
        searchCompanies() {
            axios.get(`${this.$store.state.apiUrl}/hsdata/search/companies/${encodeURIComponent(this.searchCompanyInput)}`)
                .then(resp => {
                    this.searchCompanyResults = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        searchCompaniesDebounce() {
            clearTimeout(this.companySearchDebounceTimer);
            this.companySearchDebounceTimer = setTimeout(() => { this.searchCompanies() }, 500);
        },
    }
})
